/**
 * Where a notice pinned to the bottom of the planner (the route-changed
 * toast, the routing indicator) sits: just above the elevation profile when
 * it's showing, else a little way up from the bottom edge. Pure.
 */
export function bottomNoticeOffsetPx(input: {
  /** The elevation panel's top edge in the viewport, or null when it isn't showing. */
  panelTop: number | null;
  viewportHeight: number;
  /** Room for another notice already sitting there. */
  stackedBy?: number;
  gap?: number;
  fallback?: number;
}): number {
  const { panelTop, viewportHeight, stackedBy = 0, gap = 12, fallback = 32 } = input;
  const above = panelTop != null && panelTop > 0 && panelTop < viewportHeight;
  return (above ? viewportHeight - panelTop + gap : fallback) + stackedBy;
}

/** The elevation profile's top edge, when it's on the page. */
export function elevationPanelTop(): number | null {
  const panel = document.querySelector('.plan-trail-elevation');
  if (!panel) return null;
  const rect = panel.getBoundingClientRect();
  return rect.height > 0 ? rect.top : null;
}
